var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('div',{staticClass:"alert-main"},[_c('v-alert',{attrs:{"border":"left","close-text":_vm.$t('close_toast'),"type":_vm.type,"dark":""}},[_vm._v(_vm._s(_vm.msg))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }